import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
// eslint-disable-next-line import/extensions
import campaignCacheManager from '@bingads-webui-campaign-legacy/cache-manager/index';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { ServerErrorMap } from '../error-map';

globalContext.require('component/api-errors-campaign/index');

export function InlineEditableSave({
  view,
  updated,
  editorViewCallbackAfterUpdate,
  editorView,
}) {
  const { scope } = view;

  const payloadDelete = {
    NegativeKeywords: {
      Id: updated.Id,
      ParentId: scope.values.nkl,
      Status: 'Deleted',
    },
  };

  const payloadCreate = {
    NegativeKeywords: {
      ParentId: scope.values.nkl,
      MatchType: updated.MatchType,
      Keyword: updated.Text,
    },
  };

  const edmAccount = edmCampaign
    .Customers
    .$withKey(scope.values.cid)
    .Accounts
    .$withKey(scope.values.aid);

  const handleCreationSuccess = () => {
    edmAccount.bulkCreate(payloadDelete)
      .then(() => {
        if (editorViewCallbackAfterUpdate && _.isFunction(editorViewCallbackAfterUpdate)) {
          editorViewCallbackAfterUpdate();
        }
      })
      .then(() => {
        campaignCacheManager.invalidate('NegativeKeyword');
        view.grid.gridView.refresh(true);
      })
      .finally(withUiBlock(view.grid.gridView.$el));
  };

  const handleCreationError = (response) => {
    editorView.setErrors({
      Text: _.result(
        ServerErrorMap,
        response && response.errors && response.errors[0] && response.errors[0].Type === 'Shared Negative Keyword Error' && response.errors[0].Error,
        ServerErrorMap.fallbackMsg
      ),
    });
  };

  edmAccount.bulkCreate(payloadCreate)
    .then(handleCreationSuccess, handleCreationError)
    .finally(withUiBlock(view.grid.gridView.$el));
}
